import {React, Accordion, AccordionPanel, CollapsedContent, _n} from 'pexui';
import * as utils from '../utilities/utils';
import { BasePage} from './base';
import { Button, RadioButon, Link} from './comps/uicomps';
import {uploadAFile, FileButton, FilesList} from './docupload/files';
import {flow, getTrackLabel} from '../models/flow';
import {DocUploadService} from '../services/docuploadsvc';
import {ChoiceSection} from './comps/choice';
import {RequiredDocSection} from './comps/section';
import { track } from '../utilities/track';
import globals from '../models/globals';

const getPanelTitle = (node) => {
    var value = '';
     if(node.choices){
         value = _n('choice_title');
     }else if(node.widgetOption){
         value = _n(node.widgetOption.content_id + '.title', { business_name: node.account.organization_name});
    }
    return value;
}

const nodeName = (node) => {
    if(node && typeof node.account === 'object'){
        return (node.account.organization_id || '') + '/' + (node.account.organization_name || '') + '/' + (node.code || '')+ '/' + (node.key || '');
    }else{
        return ''; // show nothing
    }
}

export class IndexPage extends BasePage {
    constructor(props){
        super(props);

        this.state = {level: flow.getCurrentLevel()};
    }

    componentDidMount(){
        if(!globals.sentOnloadEvent){
            flow.raiseInvokerEvent('loaded', undefined);
            globals.sentOnloadEvent = true;
        }
    }

    hasBackButton() {
        return flow.getCurrentLevel() > 1;
    }

    onBack(){
        flow.up();
        this.setState({level: flow.getCurrentLevel()});
    }

    getSection(node){
        if(node.choices) {
            return <ChoiceSection page={this} flow={flow} node={node}
                                  className="infw-panel-content"/>;
        }else{
            return <RequiredDocSection page={this} flow={flow} node={node}
                                       className="infw-panel-content"/>;
        }
    }

    renderContent(){
        // if only 1 choices, show the ChoiceSection without an Accordion
        if(flow.currLevelNodes.length === 1){
            let currentNode = flow.currLevelNodes[0];
            var contentsComp = <div className="infw-single-box" >
                <div className="infw-accordion-header">{getPanelTitle(currentNode)}</div>
                {this.getSection(currentNode)}
            </div>;
        }else{
            const panels = flow.currLevelNodes.map( node=> (
                <AccordionPanel name={nodeName(node)}
                    title={getPanelTitle(node)}
                    renderExpanded={()=>{
                        return this.getSection(node);
                    }}
                    renderCollapsed={node.choices? false: ()=>(
                        <FilesList node={node} withRemove={false} withComment={false}/>
                    )}
                />
              ));
            var contentsComp = <Accordion
                    widget={this.props.widget}
                    active={nodeName(flow.getCurrentNode())}
                    style={{width: "100%"}}
                    onSelect={panelName=>{
                        const currNode = utils.findArray(flow.currLevelNodes, (node)=>(nodeName(node) === panelName));
                        flow.setCurrentNode(currNode);
                        track('', {
                          contentName: getTrackLabel(currNode),
                          selfServiceStart: true
                        });
                    }}
                    >
                  {panels}
               </Accordion>
        }

        return [
               <div className="infw-message-wrapper">
                   <div className="infw-message">
                      {utils.getHtml(_n("widget.message"))}
                   </div>
               </div>,
               contentsComp
            ];
    }
}



// WEBPACK FOOTER //
// ./application/src/views/index.jsx